import { provideRouter } from '@angular/router';
import { routes } from './app.routes';

import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { ConfigService } from './core/services/config.service';
import { ThemeService } from './core/services/theme.service';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { provideAnimations } from '@angular/platform-browser/animations';

import { PoHttpRequestModule } from '@po-ui/ng-components';

import { basicAuthInterceptor } from './core/interceptors/basic-auth.interceptor';
import { lookupValorInterceptor } from './core/interceptors/lookup-valor.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    importProvidersFrom([PoHttpRequestModule]),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptors([lookupValorInterceptor, basicAuthInterceptor])),
    provideAnimations(),
    {
      provide: APP_INITIALIZER,
      useFactory: (config: ConfigService) => () => config.loadConfig(),
      deps: [ConfigService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (theme: ThemeService) => () => theme.applyInitial(),
      deps: [ThemeService],
      multi: true
    }
  ],
};
